import React, { useEffect } from "react";
import { GuideLayout } from "./GuideLayout";
import { trackEvent } from "../../analytics";

export default function AIESGReportingGuide() {
  useEffect(() => {
    trackEvent("guide_view", {
      guide: "ai_esg_reporting",
      path: window.location.pathname
    });
  }, []);

  return (
    <GuideLayout
      eyebrow="AI ESG Reporting Guide"
      title="AI ESG Reporting: How Artificial Intelligence Accelerates Sustainability Disclosure"
      description="Learn how AI can streamline ESG data collection, gap analysis, disclosure drafting, and sustainability reporting workflows."
      sections={[
        {
          id: "overview",
          heading: "What is AI ESG reporting?",
          body: [
            "AI ESG reporting uses artificial intelligence to support sustainability data management, reporting workflows, disclosure drafting, and ESG decision making."
          ]
        },
        {
          id: "benefits",
          heading: "Benefits of AI for ESG teams",
          body: [
            "AI can reduce manual work, improve consistency, identify disclosure gaps, and accelerate reporting cycles."
          ]
        }
      ]}
      faqs={[
        {
          question: "Can AI replace ESG professionals?",
          answer:
            "No. AI assists experts but does not replace governance, judgment, or assurance."
        }
      ]}
      ctaTitle="Accelerate ESG reporting with Ecovanta"
      ctaText="Use AI-assisted workflows to prepare sustainability disclosures faster."
      onCtaClick={() =>
        trackEvent("demo_click", {
          source: "ai_esg_reporting_guide",
          path: window.location.pathname
        })
      }
    />
  );
}